import './AuthRedirect.scss';

import React, { useEffect } from 'react';

import LoadingIcon from 'components/Shared/LoadingIcon/LoadingIcon';
import { useHistory, useParams } from 'react-router-dom';
import useAuth from 'hooks/useAuth';

/**
 * This page is used to trigger an RP initiated authentication flow using the Control Tower.
 * The RedirectIndex page is kept for alternate authentication flows while we migrate those to RP initiated as well.
 * In the future, this page may need to distinguish between CT/SAML/Other auth pathways.
 * @returns A page that redirects to the control tower login page to authenticate the user.
 */

export default function AuthRedirect() {
  const { pid: projectID } = useParams<{ pid: string }>();
  const { requestAuth } = useAuth(projectID);
  const history = useHistory();

  useEffect(() => {
    if (projectID) {
      requestAuth();
    } else {
      history.replace('/not-found');
    }
  }, [requestAuth, history, projectID]);

  return (
    <div className="auth-callback-container">
      <div className="content">
        <LoadingIcon />
        <div>Please wait a few seconds while as we authenticate you...</div>
      </div>
    </div>
  );
}
